// extracted by mini-css-extract-plugin
export default {"snackbar":"snackbar_snackbar__IE8Xg","on":"snackbar_on__90NuA"};